module.exports = __webpack_public_path__ + "img/fig07.05ec0b33.jpg";